<template>
  <section style="margin: 20px;">
    <nav class="level">
    <!-- SNS ShareButtons -->
      <b-icon icon="share-variant" type="is-dark" title="SNS Share"></b-icon>
      <!-- Twitter -->
      <div class="level-item has-text-centered">
        <a :href="twitterUrl()" target="_blank" data-show-count="false" data-lang="ja">
          <b-button type="is-primary" icon-pack="fab" icon-left="twitter">
            Twitter
          </b-button>
        </a>
      </div>
      <!-- Facebook -->
      <div class="level-item has-text-centered">
        <a :href="facebookUrl()" target="_blank" data-layout="button_count">
          <b-button type="is-primary" icon-pack="fab" icon-left="facebook-f">
            Facebook
          </b-button>
        </a>
      </div>
      <!-- LINE -->
      <div class="level-item has-text-centered">
        <a :href="lineUrl()" target="_blank">
          <b-button type="is-primary" icon-pack="fab" icon-left="line">
            LINE
          </b-button>
        </a>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'ShareButtons',

  props: ['title'],

  data: function() {
    return {
      twitter_url: 'https://twitter.com/intent/tweet?url={0}&text={1}',
      facebook_url: 'https://www.facebook.com/sharer/sharer.php?u={0}&text={1}',
      line_url: 'https://social-plugins.line.me/lineit/share?url={0}&text={1}'
    }
  },

  mounted() {
    if (!document.getElementById('facebook-jssdk')) {
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v5.0&appId=1586330571660266&autoLogAppEvents=1'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
    }

    if (!document.getElementById('twitter-wjs')) {
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://platform.twitter.com/widgets.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'twitter-wjs')
    }
  },

  methods: {
    formatByArr(msg) {
      var args = []
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i]
      }
      args = args.map(x => encodeURIComponent(x))
      return msg.replace(/\{(\d+)\}/g, function(m, k) {
        return args[k]
      })
    },

    twitterUrl() {
      return this.formatByArr(this.twitter_url, location.href, this.title)
    },
    facebookUrl() {
      return this.formatByArr(this.facebook_url, location.href, this.title)
    },
    lineUrl() {
      return this.formatByArr(this.line_url, location.href, this.title)
    }
  }
}
</script>

<style>
</style>
